import { useMutation, useQueryClient } from '@tanstack/react-query';
import { publicPost } from '@/lib/api/publicClient';
import { publicBookingEndpoints } from '@/lib/api/endpoints';
import { availabilityKeys } from './useAvailability';
import type { CreateOnlineBookingDto, OnlineBookingConfirmation } from '@/types/onlineBooking';

export function useCreateOnlineBooking(key: string) {
  const queryClient = useQueryClient();
  return useMutation<OnlineBookingConfirmation, Error, CreateOnlineBookingDto>({
    mutationFn: (dto) =>
      publicPost<OnlineBookingConfirmation>(publicBookingEndpoints.createBooking(key), dto),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: availabilityKeys.all() });
    },
  });
}
